import styled from 'styled-components'
import { Button } from '../../assets'

export const ModalHeading = styled.h2`
    font-size: 20px;
    font-style: normal;
    font-weight: 600;
    text-align: center;
    margin: 0 0 25px;
`

export const ModalButtons = styled.div`
    display: flex;
    flex-direction: row;
    justify-items: center;
    gap: 25px;
    width: 90%;
    margin: 0 auto;

    @media screen and (min-width: 479px) {
        width: 70%;
    }
`
export const StyledCheckbox = styled.div`
    display: block;
    margin-bottom: 25px;

    label {
        cursor: pointer;
        color: #000000;
        font-size: 16px;
        font-weight: 600;
        position: relative;
        display: flex;
        margin: 0;
    }
    input {
        padding: 0;
        height: initial;
        width: initial;
        margin-bottom: 0;
        display: none;
        cursor: pointer;
    }
    label:before {
        content: '';
        -webkit-appearance: none;
        background-color: #ffffff;
        border-radius: 4px;
        border: 1px solid ${Button.primary.defaultColor.active.color};
        padding: 10px;
        display: inline-block;
        position: relative;
        vertical-align: middle;
        cursor: pointer;
        width: 21px;
        height: 21px;
        margin-right: 5px;
        -webkit-box-sizing: border-box;
        -moz-box-sizing: border-box;
        box-sizing: border-box;
    }
    input:checked + label:after {
        content: '';
        display: block;
        position: absolute;
        top: 3px;
        left: 8px;
        width: 7px;
        height: 13px;
        border: solid #fff;
        border-width: 0 2px 2px 0;
        transform: rotate(45deg);
        -webkit-box-sizing: border-box;
        -moz-box-sizing: border-box;
        box-sizing: border-box;
    }
    input:checked + label:before {
        border-radius: 4px;
        border: 1px solid ${Button.primary.defaultColor.active.color};
        background-color: ${Button.primary.defaultColor.active.color};
        -webkit-box-sizing: border-box;
        -moz-box-sizing: border-box;
        box-sizing: border-box;
    }
    p {
        margin: 0 0 0 27px;
        color: #000;
        font-size: 12px;
        font-weight: 400;
    }
`
